export function onlyDigitsPhone(raw: string) {
  return raw.replace(/\D/g, '').slice(0, 11);
}

export function isCompleteBrazilianPhone(raw: string) {
  const digits = onlyDigitsPhone(raw);
  return digits.length >= 10 && digits.length <= 11;
}
